import { CHANGE_EDITOR_FOCUS, SET_EDITOR_MODE } from './types'

export const doChangeEditorFocus = isFocused => ({
  type: CHANGE_EDITOR_FOCUS,
  payload: { isFocused },
})

export const doSetEditorMode = mode => ({
  type: SET_EDITOR_MODE,
  payload: mode,
})
